/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { ShipmentActivity } from './shipment-activities.models';
import { common } from '@qwyk/models';

export const init = createAction(
    '[Portals/Shipments/Activities] Init',
    props<{ shipmentId: string }>()
);

export const loadShipmentActivitiesSuccess = createAction(
    '[Portals/Shipments/Activities] Load ShipmentActivities Success',
    props<{
        shipmentActivities: ShipmentActivity[];
        pagination: common.PaginationMeta;
    }>()
);

export const loadShipmentActivitiesFailure = createAction(
    '[Portals/Shipments/Activities] Load ShipmentActivities Failure',
    props<{ error: any }>()
);

export const loadMoreShipmentActivities = createAction(
    '[Portals/Shipments/Activities] Load More ShipmentActivities',
    props<{ shipmentId: string }>()
);

export const loadMoreShipmentActivitiesSuccess = createAction(
    '[Portals/Shipments/Activities] Load More ShipmentActivities Success',
    props<{
        shipmentActivities: ShipmentActivity[];
        pagination: common.PaginationMeta;
    }>()
);

export const loadMoreShipmentActivitiesFailure = createAction(
    '[Portals/Shipments/Activities] Load More ShipmentActivities Failure',
    props<{ error: any }>()
);

export const createShipmentActivitiesComment = createAction(
    '[Portals/Shipments/Activities] Create ShipmentActivitiesComment',
    props<{ shipmentId: string; payload: any }>()
);

export const createShipmentActivitiesCommentSuccess = createAction(
    '[Portals/Shipments/Activities] Create ShipmentActivities Comment Success',
    props<{ shipmentActivity: ShipmentActivity }>()
);

export const createShipmentActivitiesCommentFailure = createAction(
    '[Portals/Shipments/Activities] Create ShipmentActivities Comment Failure',
    props<{ error: any }>()
);

export const reset = createAction('[Portals/Shipments/Activities] Reset');

export const dismissError = createAction(
    '[Portals/Shipments/Activities] Dismiss Error'
);
